<template>
    <div class="about">
        <Inbanner />
        <Content />
        <Client />
    </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
import Content from './pages/Content'
import Client from './pages/Client'
export default{
    data() {
        return {
            videosrc: require('../../assets/img/video/about.mp4'),
            Englishup: "About",
            Englishdown: "us",
            zhname: "关于我们",
        };
    },
    components:{
        Inbanner,Content,Client
    }
}
</script>
<style>
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.about .rx-title {
    font-size: 22px;
    margin: 30px 0;
    font-weight: 700;
} 
</style>